import { CustomFormApiTypes } from 'apis/customForms/types';

import { CustomForm } from '../../customForms.types';

export const formListConverter = {
  toInternal: transformFormsListResponse,
};

export function transformFormsListResponse(
  customForms: CustomFormApiTypes['FormsList'],
): CustomForm[] {
  return customForms.map((formListItem) => ({
    id: formListItem.id,
    title: formListItem.label,
    submitButtonLabel: formListItem.submit_button_label,
    feedbackAfterSubmit: formListItem.submit_success_message,
    fields: [], // `attributes` are not present in the forms listing response. For type-correctness, we leave it as an empty array.
    usage:
      formListItem.flows?.map(({ id, name, channel }) => ({
        flowId: id,
        flowTitle: name,
        flowChannel: channel,
      })) ?? [],
    hasAttributes: formListItem.has_attributes,
  }));
}
